import { isInterval } from "@components/conditionalFilterDialog/ConditionalFilterDialog.utils";
import { TDateRangePickerValue } from "@components/inputs/date/popup/Calendar.utils";
import { isSameInterval } from "@components/inputs/date/utils/DateUtils";

export const isSameRange = (val1: TDateRangePickerValue, val2: TDateRangePickerValue): boolean => {
    const val1IsInterval = isInterval(val1);
    const val2IsInterval = isInterval(val2);

    if (val1IsInterval !== val2IsInterval) {
        return false;
    }

    if (val1IsInterval && val2IsInterval) {
        return isSameInterval(val1, val2);
    }

    return val1 === val2;
};